import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  bestSellerOne,
} from "../../../assets/images/index";

const BestSellers = () => {
  return (
    <div className="w-full pb-20">
      <Heading heading="Our Bestsellers" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">
        <Product
          _id="1011"
          img={bestSellerOne}
          productName="Cardomom"
          price="460"
          color="100gm"
          badge={true}
          des={`Sourced from the misty hills of Idukki, Kerala, our cardamom is handpicked to bring you the purest flavor and aroma. Known as the "Queen of Spices," cardamom adds a rich, refreshing taste to both sweet and savory dishes. Whether for cooking, baking, or brewing a soothing cup of chai, Heritage Harvest cardamom ensures unmatched freshness, natural oils, and authentic Kerala quality.`}
          ogprice="899"
        />
      </div>
    </div>
  );
};

export default BestSellers;
